<!-- Outer layout container -->
<div class="page-innder-body portlet light">
  <div class="portlet-body">
    <!-- Skeleton Loader -->
    @if (loading) {
      <div class="skeleton-loader">
        <div class="d-flex justify-content-between align-items-center p-3" style="background: #fff; border: 1px solid #e2e8f0; border-radius: 10px; margin-bottom: 1rem;">
          <div>
            <div class="skeleton" style="width: 140px; height: 24px; margin-bottom: 8px;"></div>
            <div class="skeleton" style="width: 400px; height: 14px;"></div>
          </div>
          <div class="skeleton" style="width: 110px; height: 36px; border-radius: 6px;"></div>
        </div>
        <div style="background: #fff; border: 1px solid #e2e8f0; border-radius: 10px; overflow: hidden;">
          <div class="skeleton" style="width: 50%; height: 40px; border-radius: 6px; margin: 16px;"></div>
          <div class="d-flex py-2 px-3" style="border-bottom: 1px solid #e9ecef; gap: 16px;">
            <div class="skeleton" style="width: 5%; height: 18px;"></div>
            <div class="skeleton" style="width: 25%; height: 18px;"></div>
            <div class="skeleton" style="width: 40%; height: 18px;"></div>
            <div class="skeleton" style="width: 15%; height: 18px;"></div>
            <div class="skeleton" style="width: 12%; height: 18px;"></div>
          </div>
          @for (i of [1,2,3,4,5,6,7,8]; track i) {
            <div class="d-flex py-3 px-3" style="border-bottom: 1px solid #f1f5f9; gap: 16px;">
              <div class="skeleton" style="width: 5%; height: 16px;"></div>
              <div class="skeleton" style="width: 25%; height: 16px;"></div>
              <div class="skeleton" style="width: 40%; height: 16px;"></div>
              <div class="skeleton" style="width: 15%; height: 16px;"></div>
              <div class="skeleton" style="width: 12%; height: 16px;"></div>
            </div>
          }
        </div>
      </div>
    }

    @if (!loading) {
      <!-- Page Header -->
      <div class="page-header">
        <div class="page-header-content">
          <div class="page-header-text">
            <h1 class="page-title">{{ 'artType.artTypes' | transloco }}</h1>
            <p class="page-subtitle">{{ 'artType.pageSubtitle' | transloco }}</p>
          </div>
          <div class="page-header-action">
            <button type="button" class="btn btn-outline-primary" (click)="showDialog()">
              <i class="fa fa-plus me-1"></i> {{ 'artType.addNew' | transloco }}
            </button>
          </div>
        </div>
      </div>
      <!-- Table display section -->
      <div class="table-responsive mt-3">
        <p-table #dt [value]="artTypes" dataKey="Id" [rowHover]="true"
          [globalFilterFields]="['Name','Description']" selectionMode="single"
          [paginator]="artTypes.length > 25" [rows]="25" [reorderableColumns]="true"
          [resizableColumns]="false">
          <!-- Table caption with search -->
          <ng-template pTemplate="caption">
            <div class="table-header">
              <div class="row">
                <div class="col-md-6 text-right">
                  <div class="searchbox rounded-3 w-100 position-relative d-flex align-items-center flex-row-reverse border bg-white">
                    <button type="button" class="bg-transparent border-0 py-2 px-3 position-absolute">
                      <i class="text-muted fa fa-search"></i>
                    </button>
                    <input type="text"
                      class="form-control form-control-sm bg-transparent w-100 h-100 shadow-none border-0 px-3 py-2"
                      (input)="dt.filterGlobal($any($event.target).value, 'contains')" [placeholder]="'artType.search' | transloco" />
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
            <!-- Table column headers -->
            <ng-template pTemplate="header">
              <tr>
                <th>#</th>
                <th [pSortableColumn]="'Name'" style="min-width: 240px;">
                  {{ 'artType.name' | transloco }} <p-sortIcon field="Name"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'Description'" style="min-width: 400px;">
                  {{ 'artType.description' | transloco }} <p-sortIcon field="Description"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'CreatedDate'" style="min-width: 150px;">
                  {{ 'artType.createdDate' | transloco }} <p-sortIcon field="CreatedDate"></p-sortIcon>
                </th>
                <th style="min-width: 120px;">{{ 'artType.actions' | transloco }}</th>
              </tr>
            </ng-template>
            <!-- Table body rows -->
            <ng-template pTemplate="body" let-rowIndex="rowIndex" let-rowData>
              <tr>
                <td class="ps-3">{{ rowIndex + 1 }}</td>
                <td class="text-uppercase ps-3">{{ rowData.Name }}</td>
                <td class="ps-3">{{ rowData.Description }}</td>
                <td class="ps-3">{{ rowData.CreatedDate | date: 'dd/MM/yyyy' }}</td>
                <td>
                  <button type="button" class="btn btn-sm btn-outline-primary ms-2 rounded-circle"
                    (click)="editArtType(rowData.Id)">
                    <i class="pi pi-pencil"></i>
                  </button>
                  <button type="button" class="btn btn-sm btn-outline-danger ms-2 rounded-circle"
                    (click)="deleteArtType(rowData.Id)">
                    <i class="pi pi-trash"></i>
                  </button>
                </td>
              </tr>
            </ng-template>
            <!-- Empty state message -->
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5" class="text-center">{{ 'artType.noRecordsFound' | transloco }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }

      <!-- Dialog popup for add/edit art type -->
      <p-dialog [header]="(isEditMode ? 'artType.editArtType' : 'artType.addArtType') | transloco" [(visible)]="visible" [modal]="true"
        [style]="{ 'width': '460px' }" (onHide)="closeDialog()">
        <form class="form-horizontal px-3">
          <div class="p-field">
            <label for="artTypeName">{{ 'artType.name' | transloco }}</label>
            <input type="text" id="artTypeName" [placeholder]="'artType.artTypeName' | transloco" [(ngModel)]="formData.Name"
              name="artTypeName" required class="form-control" />
            </div>
            <div class="p-field mt-2">
              <label for="description">{{ 'artType.description' | transloco }}</label>
              <textarea id="description" rows="4" [placeholder]="'artType.artTypeDescription' | transloco" class="form-control"
              [(ngModel)]="formData.Description" name="description" style="width: 100%; padding: 10px;"></textarea>
            </div>
            <div class="d-flex justify-content-end mt-4">
              <button type="button" pButton icon="pi pi-plus" (click)="saveArtType(true)" [label]="'artType.saveAndAddNew' | transloco"
              class="me-2 p-button-outlined" [disabled]="!formData.Name"></button>
              <button type="button" pButton icon="pi pi-check" (click)="saveArtType(false)" [label]="'artType.save' | transloco" class="p-button-outlined"
              [disabled]="!formData.Name"></button>
            </div>
          </form>
        </p-dialog>
      </div>
    </div>
